import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingsIcon } from '../../../assets/icons/svg/shared/ic-shared-settings.svg';
import { VIEWS_MAP } from '../../../router/constants';

export const AccountSettingsBlock = () => {
  const navigate = useNavigate();
  return (
    <button
      type='button'
      className='flex flex-row items-center gap-1 !w-full'
      id='account-settings'
      onClick={() => navigate(`/${VIEWS_MAP.ACCOUNT_SETTINGS}`)}
    >
      <SettingsIcon className='text-bw08' />
      <p className='text-bw08 text-[14px] font-metricR'>Account Settings</p>
    </button>
  );
};
